import { Button, Image, Text } from '@oy/ui';
import React from 'react';
import { useUITranslate } from '../../../../../hooks/useUITranslate';
import { EmptyStateInfo } from '../../type';
import styles from './SimpleCustomImage.module.css';

export const SimpleCustomImage = ({ 
  title,
  detail,
  imageName,
  stylesImage,
  headerProps,
  descriptionProps,
  actionButtons,
 }: EmptyStateInfo) => {
  const { translate } = useUITranslate();
  return (
    <div className={styles.container}>
      {
        imageName && (
          <Image
            name={imageName}
            style={stylesImage || { width: '135px', height: 'auto' }}
          />
        )
      }
      <Text
        textStyle={headerProps?.textStyle || Text.Style.HeadingMd}
        {...headerProps}>
        {title || translate('No Result Found')}
      </Text>
      <Text
        textStyle={descriptionProps?.textStyle || Text.Style.BodyLgRegular}
        {...descriptionProps}
      >
        {detail || translate('We could not find any data.')}
      </Text>
      <div className={styles.buttons}>
        {actionButtons?.map(item => (
          <Button
            buttonType={Button.Type.Outlined}
            size={Button.Size.Small}
            color={Button.Color.Primary}
            style={{ width: 'fit-content' }}
            {...item}
          />
        ))}
      </div>
    </div>
  );
};
